import * as React from 'react';
import {LazyMotion} from 'framer-motion';

const loadFeatures = () => import('./features').then((mod) => mod.default);

type MotionProviderProps = {
  children: React.ReactNode;
};

export function MotionProvider({children}: MotionProviderProps) {
  return (
    <LazyMotion strict={false} features={loadFeatures}>
      {children}
    </LazyMotion>
  );
}
